import type React from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Snackbar, SnackbarContent } from '@mui/material';

import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

import { useVersionCheck } from './util/useVersionCheck';

export const VersionChecker: React.FC = () => {
  const { isNewVersionAvailable } = useVersionCheck();
  const { t } = useTranslationWithPrefix('components.versionChecker');

  const handleReload = () => {
    globalThis.location.reload();
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={isNewVersionAvailable}
    >
      <SnackbarContent
        action={
          <Button color="primary" onClick={handleReload} size="small" startIcon={<RefreshIcon />}>
            {t('refresh')}
          </Button>
        }
        message={t('newVersionAvailable')}
      />
    </Snackbar>
  );
};
